import ReactPlayer from "react-player";
import { convertS3UrlToGcp } from "src/modules/worksheet/views/edit_enhanced/helpers";

const renderBlockAudio = (block: any) => {
    const {
        data: { audio },
    } = block;
    return (
        <div>
            <ReactPlayer
                url={convertS3UrlToGcp(audio)}
                controls
                file={{ forceAudio: true }}
                height={"60px"}
                maxWidth="100%"
            />
        </div>
    );
};

export default renderBlockAudio;
